import { NAME } from './constants';
import { router } from './router';

export const ZakaznickaSkupina = {
	name: NAME,
	router,
};
